import { ROUTES } from "@/constants/navigation";

export const PAGE_ROUTES = [
  {
    id: "home",
    path: ROUTES.home,
    titleKey: "pageTitles.home",
    descriptionKey: "pageDescriptions.home",
  },
  {
    id: "pricing",
    path: ROUTES.pricing,
    titleKey: "pageTitles.pricing",
    descriptionKey: "pageDescriptions.pricing",
  },
  {
    id: "legal",
    path: ROUTES.legal,
    titleKey: "pageTitles.legal",
    descriptionKey: "pageDescriptions.legal",
  },
  {
    id: "legalTerms",
    path: ROUTES.legalTerms,
    titleKey: "pageTitles.legalTerms",
    descriptionKey: "pageDescriptions.legalTerms",
  },
  {
    id: "legalPrivacy",
    path: ROUTES.legalPrivacy,
    titleKey: "pageTitles.legalPrivacy",
    descriptionKey: "pageDescriptions.legalPrivacy",
  },
  {
    id: "legalWorkspacePrivacy",
    path: ROUTES.legalWorkspacePrivacy,
    titleKey: "pageTitles.legalWorkspacePrivacy",
    descriptionKey: "pageDescriptions.legalWorkspacePrivacy",
  },
  {
    id: "legalCompanyDetails",
    path: ROUTES.legalCompanyDetails,
    titleKey: "pageTitles.legalCompanyDetails",
    descriptionKey: "pageDescriptions.legalCompanyDetails",
  },
  {
    id: "legalSubscription",
    path: ROUTES.legalSubscription,
    titleKey: "pageTitles.legalSubscription",
    descriptionKey: "pageDescriptions.legalSubscription",
  },
  {
    id: "legalPersonalDataConsent",
    path: ROUTES.legalPersonalDataConsent,
    titleKey: "pageTitles.legalPersonalDataConsent",
    descriptionKey: "pageDescriptions.legalPersonalDataConsent",
  },
  {
    id: "account",
    path: ROUTES.account,
    titleKey: "pageTitles.account",
    descriptionKey: "pageDescriptions.account",
  },
  {
    id: "accountComponent",
    path: ROUTES.accountComponent,
    titleKey: "pageTitles.account",
    descriptionKey: "pageDescriptions.account",
  },
  {
    id: "profile",
    path: ROUTES.profile,
    titleKey: "pageTitles.profile",
    descriptionKey: "pageDescriptions.profile",
  },
  {
    id: "projectDetail",
    path: ROUTES.projectDetail,
    titleKey: "pageTitles.projectDetail",
    descriptionKey: "pageDescriptions.projectDetail",
  },
  {
    id: "organizationDetail",
    path: ROUTES.organizationDetail,
    titleKey: "pageTitles.account",
    descriptionKey: "pageDescriptions.account",
  },
  {
    id: "elementStore",
    path: ROUTES.elementStore,
    titleKey: "pageTitles.elementStore",
    descriptionKey: "pageDescriptions.elementStore",
  },
  {
    id: "users",
    path: ROUTES.users,
    titleKey: "pageTitles.users",
    descriptionKey: "pageDescriptions.users",
  },
  {
    id: "userDetail",
    path: ROUTES.userDetail,
    titleKey: "pageTitles.userDetail",
    descriptionKey: "pageDescriptions.userDetail",
  },
  {
    id: "register",
    path: ROUTES.register,
    titleKey: "pageTitles.register",
    descriptionKey: "pageDescriptions.register",
  },
  {
    id: "login",
    path: ROUTES.login,
    titleKey: "pageTitles.login",
    descriptionKey: "pageDescriptions.login",
  },
  {
    id: "confirmEmail",
    path: ROUTES.confirmEmail,
    titleKey: "pageTitles.confirmEmail",
    descriptionKey: "pageDescriptions.confirmEmail",
  },
  {
    id: "forgotPassword",
    path: ROUTES.forgotPassword,
    titleKey: "pageTitles.forgotPassword",
    descriptionKey: "pageDescriptions.forgotPassword",
  },
  {
    id: "resetPassword",
    path: ROUTES.resetPassword,
    titleKey: "pageTitles.resetPassword",
    descriptionKey: "pageDescriptions.resetPassword",
  },
  {
    id: "realmDomainLogin",
    path: ROUTES.realmDomainLogin,
    titleKey: "pageTitles.realmDomainLogin",
    descriptionKey: "pageDescriptions.realmDomainLogin",
  },
] as const;

export const NOT_FOUND_ROUTE = {
  id: "notFound",
  path: "*",
  titleKey: "pageTitles.notFound",
  descriptionKey: "pageDescriptions.notFound",
} as const;

export type PageRoute = (typeof PAGE_ROUTES)[number];
export type NotFoundRoute = typeof NOT_FOUND_ROUTE;
export type RouteMetadata = PageRoute | NotFoundRoute;
export type PageRouteId = PageRoute["id"] | NotFoundRoute["id"];

export function getRouteMetadataByPathname(pathname: string): RouteMetadata {
  const normalizedPathname = pathname.replace(/\/+$/, "") || "/";
  return PAGE_ROUTES.find((route) => routeMatchesPathname(route.path, normalizedPathname))
    ?? NOT_FOUND_ROUTE;
}

function routeMatchesPathname(routePath: string, pathname: string): boolean {
  if (!routePath.includes(":")) return routePath === pathname;

  const routeSegments = routePath.split("/").filter(Boolean);
  const pathnameSegments = pathname.split("/").filter(Boolean);
  if (routeSegments.length !== pathnameSegments.length) return false;

  return routeSegments.every((segment, index) => (
    segment.startsWith(":") || segment === pathnameSegments[index]
  ));
}

// Public pages eligible for search indexing.
export const INDEXABLE_ROUTE_IDS = [
  "home", "pricing", "legal",
] as const;

export function isIndexableRoute(route: RouteMetadata): boolean {
  return INDEXABLE_ROUTE_IDS.some((id) => id === route.id);
}
